var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomeIllustration(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "431px",
    height: "493px",
    viewBox: "0 0 431 493",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "roles") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "50%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDC9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD7BF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.7836902%",
    y1: "79.2596057%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD7BF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD7BF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "68.0808905%",
    y1: "33.8281772%",
    x2: "50%",
    y2: "91.8916494%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C6AC7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45C2E1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.3525246%",
    y1: "41.1245943%",
    x2: "59.3470236%",
    y2: "82.1114603%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDC9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD1B6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "97.1591984%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD3FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85A4E1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "36.2892331%",
    y1: "100%",
    x2: "81.7034578%",
    y2: "100%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA098",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8E8E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "30.3356073%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDDDD",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "24.5839835%",
    x2: "50%",
    y2: "91.1591087%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F8F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCFA6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "69.1119227%",
    x2: "50%",
    y2: "94.3901528%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD1B6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDC9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D455C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F0C0C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDC9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC39F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "9.54471848%",
    y1: "75.8124142%",
    x2: "100%",
    y2: "58.5870487%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FFEE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "52.4809966%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFFAFD",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "46.9663657%",
    y1: "46.6138774%",
    x2: "52.7078823%",
    y2: "79.9164935%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FCFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCDDEC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "26.3820652%",
    cy: "64.9228882%",
    fx: "26.3820652%",
    fy: "64.9228882%",
    r: "48.4512686%",
    id: "radialGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8FF4A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "48.0490779%",
    x2: "41.8824188%",
    y2: "54.4021712%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECF05",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "34.7800238%",
    x2: "41.8824188%",
    y2: "84.343217%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECF05",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.4161623%",
    y1: "0%",
    x2: "48.4712707%",
    y2: "162.822834%",
    id: "linearGradient-17"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECF05",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "18.5924105%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3D1FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.7033186%",
    y1: "50%",
    x2: "59.2418164%",
    y2: "86.8289533%",
    id: "linearGradient-19"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4FFF2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "38.9167385%",
    y1: "0%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D387FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "12.1863812%",
    y1: "49.6047764%",
    x2: "84.1590375%",
    y2: "50.2068202%",
    id: "linearGradient-21"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD85A",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF54",
    offset: "36.7078234%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "12.1863812%",
    y1: "49.7312867%",
    x2: "84.1590375%",
    y2: "50.1406174%",
    id: "linearGradient-22"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD85A",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF54",
    offset: "36.7078234%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "65.5915284%",
    y1: "21.8795947%",
    x2: "35.9782134%",
    y2: "80.8970741%",
    id: "linearGradient-23"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF49E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAFCF8",
    offset: "52.0067953%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3C7E7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.9170076%",
    y1: "18.2436442%",
    x2: "54.1029107%",
    y2: "91.4517179%",
    id: "linearGradient-24"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9E9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "20.9102476%",
    y1: "21.6467192%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-25"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC6A4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD8C1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-26"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDC9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA92",
    offset: "99.9023438%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "10.5893149%",
    id: "linearGradient-27"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08312B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A1111",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "41.8395132%",
    y1: "65.782329%",
    x2: "0%",
    y2: "50%",
    id: "linearGradient-28"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDCDCD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-29"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-30"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0EFEF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-31"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "80.4499936%",
    y1: "50%",
    x2: "50%",
    y2: "87.5182583%",
    id: "linearGradient-32"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD8C1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC4A1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "83.7583158%",
    y1: "40.3868448%",
    x2: "50%",
    y2: "40.3868448%",
    id: "linearGradient-33"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575757",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424242",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "5.814675%",
    y1: "55.1275355%",
    x2: "65.4272455%",
    y2: "38.607824%",
    id: "linearGradient-34"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575",
    offset: "36.0576923%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424242",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "31.7761822%",
    id: "linearGradient-35"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB88E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD8C1",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Landing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00-landing",
    transform: "translate(-130.000000, -118.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "roles",
    transform: "translate(130.000000, 118.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-1",
    transform: "translate(0.810716, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.408653,65.8960257 L208.044726,63.0096863 C208.595103,62.9638215 209.078452,63.3728095 209.124317,63.9231865 C209.126619,63.9508085 209.127771,63.9785143 209.127771,64.006232 L209.127771,91.7011625 C209.127771,92.2212512 208.729109,92.6545173 208.210817,92.6977083 L173.574744,95.5840477 C173.024367,95.6299124 172.541018,95.2209244 172.495153,94.6705474 C172.492851,94.6429254 172.491699,94.6152197 172.491699,94.5875019 L172.491699,66.8925714 C172.491699,66.3724828 172.890361,65.9392167 173.408653,65.8960257 Z",
    id: "Rectangle",
    fill: "#FF57D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.646357,103.529545 L186.11078,100.079703 C186.657654,100.002586 187.163499,100.383399 187.240616,100.930273 C187.247139,100.976531 187.250413,101.02319 187.250413,101.069906 L187.250413,120.505547 C187.250413,121.003884 186.8835,121.426166 186.390046,121.495751 L161.925624,124.945593 C161.378749,125.02271 160.872904,124.641897 160.795787,124.095023 C160.789264,124.048764 160.78599,124.002106 160.78599,123.95539 L160.78599,104.519748 C160.78599,104.021412 161.152903,103.599129 161.646357,103.529545 Z",
    id: "Rectangle",
    fill: "#EEFFDC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "customer-service",
    transform: "translate(194.959581, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7310381,168.338985 C33.0699155,177.94283 30.2393542,185.572368 30.2393542,191.227601 C30.2393542,196.882833 42.3122251,212.094082 66.457967,236.861348 C68.6692449,237.493415 71.026579,237.015638 73.5299694,235.428015 C76.0333597,233.840392 76.6455742,231.67561 75.3666129,228.933669 C70.5004361,218.494293 66.9675113,211.377622 64.7678384,207.583657 C62.5681656,203.789692 58.941609,198.6738 53.8881686,192.235981 C64.3535696,183.560783 72.1525317,177.464953 77.2850549,173.948491 C84.9838397,168.673798 87.6011186,160.251866 77.2850549,150.035214 C70.4076791,143.224113 57.5563402,149.32537 38.7310381,168.338985 Z",
    id: "Path-5",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5953629,184.695042 C44.3803644,192.400071 40.2728651,199.080202 40.2728651,204.735434 C40.2728651,210.390667 41.5498031,225.579377 44.103679,250.301566 C46.0586124,251.080935 48.256285,251.47062 50.6966966,251.47062 C53.1371083,251.47062 55.3962989,251.080935 57.4742685,250.301566 C60.0641442,238.318996 61.3590821,229.777555 61.3590821,224.677243 C61.3590821,219.576932 60.8190824,214.679833 59.739083,209.985947 C75.5467576,200.381476 86.0168565,193.821009 91.1493797,190.304547 C98.8481645,185.029854 101.465443,176.607923 91.1493797,166.391271 C84.2720039,159.580169 71.420665,165.681426 52.5953629,184.695042 Z",
    id: "Path-5",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.01303,136.627836 C122.796712,143.092119 122.796712,152.217472 120.01303,164.003894 C117.229349,175.790316 101.018688,189.345857 71.3810489,204.670516 C64.1043466,195.836476 57.1709949,189.389585 50.5809938,185.329842 C43.9909927,181.270099 37.9883375,178.949819 32.5730283,178.369001 C40.5790041,160.112383 49.1844662,147.341585 58.3894146,140.056607 C67.594363,132.771629 73.9921975,128.263102 77.5829182,126.531027 C82.3164433,122.941442 88.8025776,121.889528 97.0413212,123.375285 C105.280065,124.861041 112.937301,129.278558 120.01303,136.627836 Z",
    id: "Path-4",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "r-hand",
    transform: "translate(0.118237, 53.261370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1227672,40.8453521 C21.1032074,38.6208379 19.5247996,36.6830492 18.3875437,35.0319861 C16.6816599,32.5553914 16.726244,30.7430053 15.677435,29.2908859 C14.9782289,28.3228063 14.1876182,27.3699593 13.3056029,26.4323447 C12.9422928,26.101622 12.560947,26.3500183 12.1615656,27.1775336 C11.7621842,28.005049 12.0195168,29.3495488 12.9335635,31.2110332 C12.9335635,32.2560547 12.9335635,33.1163731 12.9335635,33.7919884 C12.9335635,34.8054112 10.7733978,33.5910362 9.47136826,32.7919082 C8.82463908,32.3949745 7.8361632,31.1198093 6.87531698,30.2199277 C5.90173653,29.3081199 4.95790335,28.7675984 4.63918511,27.7596992 C4.00591741,25.7570837 3.76308544,25.0036055 2.93806273,25.0036055 C2.11304001,25.0036055 1.96045842,25.6253047 1.48215302,26.8665777 C1.33526441,27.2477753 0.665831436,28.1863753 0.310629422,29.2908859 C-0.0526356744,30.4204689 0.417447943,31.4834048 0.310629422,32.7919082 C0.203861673,34.0997896 0.989099987,36.8227438 1.48215302,37.6454609 C2.95083197,40.0961249 4.26433219,42.8562569 9.10971743,44.4422807 C13.9551027,46.0283045 16.2081159,46.7664794 18.3875437,48.0001007 C19.8404956,48.8225149 21.4189034,49.3543069 23.1227672,49.5954766 C23.9189329,48.9632209 24.5966404,47.9349197 25.1558898,46.5105731 C25.7151392,45.0862265 25.0374317,43.1978195 23.1227672,40.8453521 Z",
    id: "Path-10",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9880904,27.5378058 C63.7934042,33.3073612 60.7662823,43.0432137 59.4466719,45.8826753 C58.1270615,48.722137 54.032431,47.6432037 45.1624831,45.8826753 C39.2491845,44.7089898 31.7539279,42.791287 22.6767132,40.129567 C22.6625523,42.3991162 22.3749354,44.3168189 21.8138626,45.8826753 C21.2527897,47.4485317 20.6677731,48.738438 20.0588127,49.7523941 C29.8834399,54.0626036 37.3622613,57.16117 42.4952768,59.0480932 C50.1948001,61.8784781 64.9935688,63.8690999 68.3866653,61.4026384 C71.7797618,58.936177 76.6972942,41.2591431 79.7751196,31.4705264 C82.988211,21.251714 87.7361225,0 76.3621064,0 C64.9880904,0 66.1827765,21.7682504 64.9880904,27.5378058 Z",
    id: "Path-8",
    fill: "#BDD3FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.0568451,52.9592452 C72.2721312,53.7996418 68.6762261,56.1302454 68.1913379,61.429775 C67.8295033,65.3844047 67.9246473,67.8331606 67.3181157,75.1583858 C67.111845,77.6495658 66.457967,81.9255348 66.457967,85.9776997 C66.457967,94.4805147 75.0568451,99.7019922 76.0120275,104.659473 C76.6488158,107.964461 76.6526797,115.54726 76.0236192,127.407871 C79.5623277,132.012225 85.8585187,134.314402 94.9121924,134.314402 C103.965866,134.314402 112.416293,135.295797 120.263472,137.258586 C118.730013,111.029319 117.963283,93.2258561 117.963283,83.8481981 C117.963283,69.7817112 115.057486,57.3727059 111.18309,53.7974057 C108.600159,51.4138722 105.401626,49.9947014 101.58749,49.5398933 C85.7568694,51.2591968 76.9133211,52.3989808 75.0568451,52.9592452 Z",
    id: "body",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9066948,129.317785 L109.75867,148.211175 C110.192163,148.372234 110.479767,148.785901 110.479767,149.248347 C110.479767,149.732806 110.252462,150.189197 109.865806,150.481082 L81.9095056,171.585229 C81.3175741,172.032077 80.52697,172.114675 79.8554608,171.799823 L27.5849295,147.291691 C27.2464077,147.132968 27.0302034,146.792807 27.0302034,146.418922 C27.0302034,146.041417 27.2369893,145.694244 27.5689301,145.514453 L57.2576173,129.433963 C57.7648344,129.159236 58.3659696,129.116885 58.9066948,129.317785 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2677771,129.07953 L110.257884,148.181555 C110.517084,148.27679 110.650005,148.564116 110.554771,148.823317 C110.520825,148.915708 110.460364,148.996024 110.380967,149.0542 L81.1844815,170.446983 C81.0380107,170.554305 80.8448689,170.573783 80.6799193,170.497867 L27.0302034,145.806247 L27.0302034,145.806247 L57.8572081,129.109203 C57.9834564,129.040822 58.1330082,129.030013 58.2677771,129.07953 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "l-hand",
    transform: "translate(68.343216, 53.346315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8315016,86.0551246 C18.9254753,87.7778188 15.7736355,89.0467314 13.3759824,89.8618624 C12.4051247,90.1919252 9.27047798,90.6054606 6.22835039,91.0845588 C4.94462652,91.2867298 4.24907012,92.0815159 3.21956258,92.8681339 C2.14042099,93.692676 0.396735886,94.4323093 0.944854324,95.6625565 C1.51790382,96.9487612 6.13977101,94.0810514 5.4097304,94.7165141 C4.57330874,95.444576 3.82673411,96.1827438 3.21956258,96.8857012 C0.930380035,99.5360195 -1.32985394,102.067496 0.944854324,103.389989 C3.21956258,104.712482 4.58037302,106.521006 7.99806191,104.955498 C11.4157508,103.389989 16.6654548,103.33133 19.7484782,101.358256 C22.8315016,99.3851822 26.3396119,95.911353 28.1146167,93.2526548 C29.8896216,90.5939566 29.8896216,89.8618624 28.1146167,87.4606542 C26.9312802,85.8598487 25.1702418,85.3913388 22.8315016,86.0551246 Z",
    id: "Path-9",
    fill: "#FFDDC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3394139,0.461040872 C45.9851569,2.17603544 49.6744498,7.60589845 53.4072925,16.7506299 C56.6303352,24.6464512 64.4047043,56.7119336 64.4047043,59.373679 C64.4047043,62.0354244 59.9969027,67.6651606 54.6033258,72.8241017 C51.0076079,76.2633957 41.9454339,83.5741808 27.4168037,94.7564572 C26.7210221,92.3191902 25.738068,90.3092956 24.4679412,88.7267735 C23.1978144,87.1442513 21.6246601,86.2064698 19.7484782,85.913429 C25.6383873,82.009942 30.3308499,77.6468329 33.8258661,72.8241017 C37.3208823,68.0013704 42.3802808,62.3018021 49.0040617,55.7253966 C47.3658174,47.6685507 45.0566606,41.1576604 42.0765913,36.1927256 C37.6064873,28.7453235 29.5060831,11.2050289 32.5321465,4.85449683 C34.5495221,0.62080878 37.8186112,-0.843676538 42.3394139,0.461040872 Z",
    id: "Path-7",
    fill: "#BDD3FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.55114997,102.831506 L61.5638742,128.903395 C61.6725642,128.953099 61.7598551,129.040092 61.809931,129.148611 L80.9471701,170.620866 L80.9471701,170.620866 L27.0302034,145.806247 L3.90454192,103.526152 C3.77202893,103.283882 3.86100484,102.98006 4.10327518,102.847547 C4.24167702,102.771846 4.40768711,102.7659 4.55114997,102.831506 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.74687,54.9974398 C73.74687,60.0123237 70.2336024,68.8011864 77.5829182,69.6639438 C84.932234,70.5267013 90.3170306,63.3709654 93.0197162,59.4241495 C95.7224017,55.4773337 103.020574,49.5398933 101.338711,49.5398933 C100.386488,49.5398933 94.8394949,49.0805163 88.496482,47.2620645 C84.4755218,46.1093124 77.7935707,45.9315519 74.5835397,48.5008575 C73.024909,49.7483841 73.74687,51.8825686 73.74687,54.9974398 Z",
    id: "sholder",
    fill: "#FFDDC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2490496,47.706882 C70.7077085,48.2898143 71.8805288,49.3626545 72.7675105,50.9254026 C74.0979832,53.2695247 76.2875249,56.3143761 79.1686864,56.3143761 C82.0498478,56.3143761 83.1325258,56.362035 84.4943037,52.0344585 C85.4021556,49.1494075 86.2288872,46.8824013 86.9744984,45.2334399 C83.6722927,42.0961783 81.7471448,39.8842993 81.1990547,38.5978031 C80.6509646,37.3113069 79.8101953,35.7282805 78.6767469,33.8487239 C74.8908007,34.0233873 71.9714631,35.1049087 69.9187339,37.0932883 C67.8660047,39.0816678 67.6427766,42.6195324 69.2490496,47.706882 Z",
    id: "neck",
    fill: "url(#linearGradient-9)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "head",
    transform: "translate(50.320715, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.2606602,20.0390987 C1.67388874,25.7522122 1.67388874,29.7734011 2.2606602,32.1026655 C3.14081739,35.5965621 6.18694988,42.8570236 9.96621254,46.8574951 C13.7454752,50.8579666 17.7088558,51.4761877 19.3836272,51.4761877 C21.0583986,51.4761877 25.8050322,49.6563548 28.1080099,46.8574951 C30.4109877,44.0586353 32.4459752,42.4787632 33.3849432,40.4230581 C34.3239112,38.3673531 37.0816703,34.6004541 38.2418471,32.7926901 C39.402024,30.984926 39.917621,28.1606707 39.917621,23.8601304 C39.917621,19.5595902 35.2655525,7.23037226 24.6354991,6.02541901 C14.0054457,4.82046577 7.94960333,8.84566454 5.49759366,13.072023 C3.86292054,15.8895953 2.78394272,18.2119539 2.2606602,20.0390987 Z",
    id: "Path-2",
    fill: "#FFDDC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.902665201,15.6543521 C2.54836534,9.57545319 9.35488088,0.819325977 20.5835681,0.819325977 C31.8122554,0.819325977 36.8641371,5.94388585 41.080471,11.5122 C45.2968049,17.0805141 44.851714,26.7721573 50.5750748,29.1673611 C56.2984357,31.5625648 57.7660326,36.4392942 56.5056101,40.9376527 C55.2451876,45.4360111 47.1132569,48.4340257 43.5154389,48.4340257 C39.917621,48.4340257 37.6928349,46.5467334 32.8576509,52.4705856 C31.9436824,50.7035882 29.4809041,41.1015118 32.1940244,37.627874 C33.7842553,35.591884 35.1970512,29.9948327 32.8576509,28.6424983 C30.5182506,27.2901638 28.46258,28.6429655 28.46258,31.2181644 C26.3216317,30.3233136 24.1400358,28.968346 23.0412584,27.2875307 C20.9250772,24.0503784 19.2063091,20.6986079 17.8849541,17.2322193 C15.7584087,18.7866959 12.9660092,20.3124353 9.50775557,21.8094377 C5.21783537,23.6664503 2.19449804,27.6845036 2.19449804,32.496297 C-0.0363027991,29.172818 -0.743034941,21.7332509 0.902665201,15.6543521 Z",
    id: "Path",
    fill: "url(#linearGradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5073421,0.819325977 C21.4777325,0.159041006 24.9401257,1.11102238 28.8945218,3.6752701 C32.6288517,6.09681481 36.5633514,10.7247226 40.6980211,17.5589936 C41.0534168,18.1464441 40.8653053,18.9107735 40.2778575,19.2661739 C40.2272924,19.2967653 40.1746101,19.3237122 40.1202117,19.3468094 C39.3682976,19.6660669 38.4957746,19.395185 38.0568545,18.706237 C33.3103533,11.2555784 29.0078496,6.4266699 25.1493434,4.2195114 C21.0879324,1.89628651 17.0908334,1.24764117 13.1580463,2.27357541 C14.2280235,1.82744141 15.0699574,1.51611047 15.6838479,1.33958256 C16.2977385,1.16305466 17.2389032,0.989635801 18.5073421,0.819325977 Z",
    id: "Rectangle",
    fill: "#FF7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9740159,42.7873511 L22.5579124,42.7873511 C21.7468763,44.8449508 19.8162268,45.8737507 16.7659642,45.8737507 C13.7157015,45.8737507 11.7850521,44.8449508 10.9740159,42.7873511 Z",
    id: "Rectangle",
    fill: "#FF6D4F",
    transform: "translate(16.765964, 44.330551) rotate(-5.000000) translate(-16.765964, -44.330551) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2676761,32.4943834 L11.0685709,33.8650073 C10.6331058,36.7430127 10.2442462,38.5021807 9.90199202,39.1425114 C9.31160354,40.2470819 10.8318858,41.0687246 11.9610173,41.1675108 C13.0901489,41.266297 13.689865,41.129919 14.2703153,40.6181878 C14.6572822,40.2770337 13.6564025,37.5690989 11.2676761,32.4943834 Z",
    id: "Path-3",
    fill: "url(#linearGradient-11)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M280.960933,164.357985 C323.442854,169.495763 357.236105,167.595324 382.340687,158.656668 C460.793901,130.722874 384.243923,113.608149 418.996936,99.3081785 C418.996936,128.631813 418.996936,161.664719 418.996936,187.159598 C413.597528,199.594132 400.535096,208.214606 378.222609,216.917463 C356.531641,225.377899 324.246962,227.194597 281.368573,222.367555 L280.960933,164.357985 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.362165,108.695074 C409.771094,111.781319 411.1214,114.704878 413.413083,117.46575 C416.850607,121.607058 419.253728,124.01147 419.253728,130.472487 C419.253728,136.933504 417.312681,138.647536 415.332862,140.913695 C414.012982,142.424468 412.02275,144.099605 409.362165,145.939107 L409.362165,108.695074 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-13)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#radialGradient-14)",
    cx: 288.509231,
    cy: 194.70568,
    r: 14.1121985
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.960933,
    y1: 199.263871,
    x2: 200.28413,
    y2: 214.989353,
    id: "Stroke-23",
    stroke: "url(#linearGradient-15)",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.960933,
    y1: 199.263871,
    x2: 223.28413,
    y2: 230.989353,
    id: "Stroke-23",
    stroke: "url(#linearGradient-16)",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.960933,
    y1: 199.263871,
    x2: 258.78413,
    y2: 252,
    id: "Stroke-23",
    stroke: "url(#linearGradient-17)",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.8,
    fill: "#FF85B6",
    cx: 402.918856,
    cy: 145.939107,
    r: 10.5200025
  }), /*#__PURE__*/React.createElement("g", {
    id: "decoration-line",
    transform: "translate(336.448089, 150.682729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,32.6366693 C9.51104203,32.7312706 18.4621406,31.707859 27.8532956,29.5664346 C37.2444506,27.4250101 45.9962801,23.9028653 54.1087841,19 L54.1087841,23.8533544 C45.5868152,28.8496034 37.0592666,32.3206141 28.5261383,34.2663864 C19.9930099,36.2121588 10.8176305,37.2867045 1,37.4900237 L1,32.6366693 Z",
    id: "Rectangle",
    fill: "#FF85B6",
    transform: "translate(27.554392, 28.245012) rotate(3.000000) translate(-27.554392, -28.245012) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4865788,34.9094449 C50.4262592,32.0945614 61.1242031,27.2530831 71.5804108,20.38501 C82.0366184,13.5169369 89.0416024,6.92286409 92.5953629,0.602791532 L92.5953629,4.9335881 C89.0416024,11.5107034 82.0366184,18.4496496 71.5804108,25.7504267 C61.1242031,33.0512037 50.4262592,37.8056246 39.4865788,40.0136894 L39.4865788,34.9094449 Z",
    id: "Rectangle",
    fill: "#97B7FF",
    transform: "translate(66.040971, 20.308240) rotate(-1.000000) translate(-66.040971, -20.308240) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.218535,94.9814312 C117.433516,84.3190162 121.465987,79.0170642 131.31595,79.0755752 L132.248504,122.792588 C125.346878,114.914232 121.003555,105.643846 119.218535,94.9814312 Z",
    id: "Rectangle",
    fillOpacity: 0.5,
    fill: "url(#linearGradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.839332,94.1763439 C121.57531,108.326934 127.453738,119.072399 136.474616,126.412741 C145.495494,133.753083 157.62205,139.449976 172.854284,143.503422 L172.854284,199.263871 C159.041254,197.266489 147.651116,193.541455 138.683871,188.088771 C129.716627,182.636086 124.048971,173.708776 121.680903,161.30684 L118.839332,94.1763439 Z",
    id: "Rectangle",
    fillOpacity: 0.85,
    fill: "url(#linearGradient-19)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "decoration-line",
    transform: "translate(148.314188, 159.953093)",
    fill: "url(#linearGradient-20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.12686414e-13,1.40858017e-14 C3.62322196,1.73769314 13.5717425,5.93731203 28.7307549,7.98416713 C43.8897674,10.0310222 50.8561355,9.73753253 57.4615099,10.214051 L57.4615099,12.9745128 C51.6817898,12.6606751 40.6015447,12.5005266 28.7307549,10.8105456 C14.8316102,8.83179859 2.72173131,4.53433731 -1.12686414e-13,3.02844856 L-1.12686414e-13,1.40858017e-14 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.12686414e-13,5.65905286 C3.62322196,7.396746 13.5717425,11.5963649 28.7307549,13.64322 C43.8897674,15.6900751 50.8561355,15.3965854 57.4615099,15.8731039 L57.4615099,18.6335656 C51.6817898,18.3197279 40.6015447,18.1595795 28.7307549,16.4695985 C14.8316102,14.4908514 2.72173131,10.1933902 -1.12686414e-13,8.68750142 L-1.12686414e-13,5.65905286 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.12686414e-13,11.3923066 C3.62322196,13.1299997 13.5717425,17.3296186 28.7307549,19.3764737 C43.8897674,21.4233288 50.8561355,21.1298391 57.4615099,21.6063576 L57.4615099,24.3668194 C51.6817898,24.0529817 40.6015447,23.8928332 28.7307549,22.2028522 C14.8316102,20.2241052 2.72173131,15.9266439 -1.12686414e-13,14.4207551 L-1.12686414e-13,11.3923066 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.12686414e-13,17.1506578 C3.62322196,18.888351 13.5717425,23.0879699 28.7307549,25.134825 C43.8897674,27.1816801 50.8561355,26.8881904 57.4615099,27.3647089 L57.4615099,30.1251706 C51.6817898,29.8113329 40.6015447,29.6511845 28.7307549,27.9612035 C14.8316102,25.9824564 2.72173131,21.6849951 -1.12686414e-13,20.1791064 L-1.12686414e-13,17.1506578 Z",
    id: "Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: "decoration-line",
    opacity: 0.608979725,
    transform: "translate(136.524181, 180.260598) rotate(9.000000) translate(-136.524181, -180.260598) translate(3.024181, 154.260598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.494124033,24.7609053 C43.1144569,32.2497974 81.1615528,37.0743854 114.635412,39.234669 L119.533216,39.5346392 C152.957414,41.4768277 201.824933,42.2667719 266.135772,41.9044715 L266.135772,35.5160481 L253.745625,35.5499676 C191.784726,35.653858 145.414655,34.7126117 114.635412,32.726229 C81.8378575,30.6095916 43.7907616,25.8250092 0.494124033,18.3724819 L0.494124033,24.7609053 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.494124033,34.1269438 C43.1144569,41.615836 81.1615528,46.4404239 114.635412,48.6007076 L117.874876,48.8026081 C151.332786,50.8162148 200.753085,51.6388487 266.135772,51.27051 L266.135772,44.8820867 L256.805452,44.9100542 C193.309246,45.0504762 145.919232,44.111214 114.635412,42.0922675 C81.8378575,39.9756302 43.7907616,35.1910478 0.494124033,27.7385205 L0.494124033,34.1269438 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.494124033,15.5234746 C43.1144569,23.0123668 81.1615528,27.8369547 114.635412,29.9972384 L117.874876,30.1991389 C151.332786,32.2127456 200.753085,33.0353796 266.135772,32.6670409 L266.135772,26.2786175 L253.745625,26.312537 C191.784726,26.4164273 145.414655,25.4751811 114.635412,23.4887984 C81.8378575,21.372161 43.7907616,16.5875786 0.494124033,9.13505129 L0.494124033,15.5234746 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.494124033,3.66400695 C41.8229317,10.2606787 78.8514687,14.6746347 111.579735,16.9058749 L114.635412,17.108659 C148.10927,19.2689427 198.609391,20.129978 266.135772,19.691765 L266.135772,17.4721559 L253.745625,17.5060753 C192.800478,17.6082626 146.939175,16.6992992 116.161715,14.7791851 L114.635412,14.6823367 C81.8378575,12.5656994 43.7907616,7.781117 0.494124033,0.328589672 L0.494124033,3.66400695 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-22)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(29.810716, 161.766389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.7800389,54.2536308 C96.3351272,72.0708516 88.9335099,85.6006295 77.5751868,94.8429644 C72.3233771,99.1163932 52.6792443,114.248825 31.0125693,121.817142 C5.81975982,130.617162 -4.7986203,139.453004 3.5971788,151.56813 L3.5971788,211.887244 C8.24461867,194.735263 39.8533751,183.621765 55.3543493,176.349481 C70.8553235,169.077196 84.8579278,155.4662 88.7170298,139.453004 L99.7800389,54.2536308 Z",
    id: "Rectangle",
    fillOpacity: 0.73,
    fill: "url(#linearGradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.767049834,143.628267 C0.767049834,149.795628 3.50190745,155.511507 8.97162267,160.775904 C14.4413379,166.040302 18.4336307,169.100567 20.9485012,169.956698 L20.9485012,243.365416 C18.4336307,243.223726 14.4413379,240.199626 8.97162267,234.293115 C3.50190745,228.386605 0.767049834,223.300719 0.767049834,219.035457 L0.767049834,143.628267 Z",
    id: "Rectangle",
    fill: "#EFF7FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "customer-service",
    transform: "translate(41.222855, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.8419832,156.084767 C69.0474123,144.27818 100.516487,144.751808 109.410612,144.751808 C118.304736,144.751808 127.113787,145.378387 136.095018,148.092522 C142.082505,149.901945 150.039122,159.235266 159.964869,176.092484 C155.590447,184.960941 150.940057,189.395169 146.0137,189.395169 C141.087342,189.395169 132.789206,184.960941 121.11929,176.092484 C113.313505,177.483671 105.731701,179.696217 98.3738806,182.730121 C87.3371494,187.280976 70.9353945,196.060217 59.3660724,189.395169 C47.7967503,182.730121 44.636554,167.891355 56.8419832,156.084767 Z",
    id: "Path-17",
    fill: "#0A2856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2335404,179.840017 C28.199616,195.032283 34.4374934,205.052735 40.9471725,209.901374 C50.7116913,217.174332 71.0297956,223.092554 82.5217185,223.092554 C94.0136414,223.092554 115.964776,220.26291 130.745069,220.26291 C140.598598,220.26291 150.338531,220.26291 159.964869,220.26291 L197.61255,247.235404 C206.819796,249.455263 212.853689,248.489862 215.71423,244.3392 C218.57477,240.188538 220.00504,234.983576 220.00504,228.724312 C197.387018,209.123811 182.296603,197.056931 174.733795,192.523671 C163.389584,185.723782 111.380498,181.500769 102.486377,179.840017 C96.556963,178.732849 86.9723946,175.145411 73.732672,169.077702 C62.7998821,169.133784 54.1545749,169.161825 47.7967503,169.161825 C41.4389256,169.161825 32.9178557,172.721222 22.2335404,179.840017 Z",
    id: "Path-16",
    fill: "#173B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6074112,50.1340247 C29.0996223,62.4109814 33.1576857,60.6925985 36.2317345,65.6021103 C39.3057832,70.511622 60.3064911,88.3824924 62.4542686,101.494242 C63.8861204,110.235408 68.5747064,133.236106 76.5200266,170.496336 C74.8923903,174.291933 72.3165274,178.369861 68.7924378,182.730121 C63.5063034,189.27051 50.2299286,189.395169 36.2317345,189.395169 C22.2335404,189.395169 20.5710239,179.156791 14.444983,163.742907 C8.31894223,148.329024 1.67390835,117.344527 0.205159685,100.151252 C-1.26358898,82.9579766 5.42038667,61.6484511 11.7425774,56.8752526 C18.0647681,52.102054 23.1382859,50.1340247 27.6074112,50.1340247 Z",
    id: "Path-13",
    fill: "url(#linearGradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.007893,44.2747534 C17.5777483,46.3027563 17.3626759,48.2558467 17.3626759,50.1340247 C17.3626759,50.1340247 17.1549907,51.003534 16.383919,52.8519136 C15.6128472,54.7002931 13.4670686,54.9173121 14.3344963,57.0988133 C15.2019239,59.2803146 17.3626759,60.1533604 24.6089115,65.6021103 C31.8551471,71.0508601 41.6705644,75.1713009 40.904983,73.4247184 C38.8318706,68.69516 36.3384298,67.059468 36.7176416,66.0579819 C37.273545,64.5898589 38.1718897,62.6216517 39.4126759,60.1533604 C36.9416118,52.7896168 34.0652733,48.5107492 30.7836602,47.3167578 C27.5020471,46.1227663 23.243458,45.1087649 18.007893,44.2747534 Z",
    id: "Path-12",
    fill: "url(#linearGradient-25)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "head",
    transform: "translate(3.586090, 0.128998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.537452,12.0663689 C45.4169184,14.773498 46.7971159,17.250717 47.6780445,19.498026 C48.9994373,22.8689896 50.5854513,33.6599658 50.5854513,37.4194697 C50.5854513,41.1789736 47.8599822,54.2327 45.7618536,57.4989295 C43.663725,60.7651591 37.9684192,65.5463821 34.8006732,65.5463821 C31.6329272,65.5463821 21.2218595,60.5941089 16.7742891,55.3080261 C12.3267187,50.0219433 4.76660475,43.2437034 3.55911034,37.4194697 C2.35161593,31.595236 1.71275718,22.209322 8.80528819,14.5866924 C15.8978192,6.96406275 20.7522037,6.78422315 28.8976527,6.78422315 C34.327952,6.78422315 39.2078851,8.54493841 43.537452,12.0663689 Z",
    id: "Path-11",
    fill: "#FFD8C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5627477,51.1358474 L45.6253314,51.1358474 C44.6407522,53.633726 42.2969883,54.8826654 38.5940396,54.8826654 C34.8910909,54.8826654 32.5473269,53.633726 31.5627477,51.1358474 Z",
    id: "Rectangle",
    fill: "#FF6D4F",
    transform: "translate(38.594040, 53.009256) rotate(-5.000000) translate(-38.594040, -53.009256) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6356743,36.1653026 L39.533258,37.5870444 L40.3899732,38.9060041 C41.8326944,41.0888973 42.8469995,42.4081954 43.4328885,42.8638982 C44.6330456,43.797377 43.352719,45.4592658 42.1492635,46.1263521 C40.945808,46.7934384 40.2133697,46.9383132 39.3169599,46.6573998 C38.7193534,46.4701243 38.4922582,42.9727585 38.6356743,36.1653026 Z",
    id: "Path-3",
    fill: "url(#linearGradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.257996204,28.0591998 C-0.465383664,21.6229836 1.07763716,13.0550013 8.12669227,6.78422315 C15.1757474,0.513445006 28.6898775,-0.275742631 31.4262255,0.428599782 C34.1625735,1.13294219 36.7147192,1.91658765 40.0284448,3.83909989 C43.3421705,5.76161212 47.2952921,8.06627035 47.6780445,10.0456778 C48.4836117,14.2116763 48.4836117,17.362459 47.6780445,19.498026 C46.4005839,17.5123686 42.5570141,16.5195398 36.1473351,16.5195398 C31.4262255,24.5573592 24.8987968,29.3986238 16.7742891,34.9053676 C15.993715,35.4344362 15.4608678,36.9425808 15.1757474,39.4298015 C14.4618636,38.6767121 13.8737385,37.8602584 13.411372,36.9804402 C12.7178223,35.660713 11.5081073,35.1808166 9.95078375,35.6195015 C8.3934602,36.0581863 8.12669227,37.8777087 8.12669227,40.6098449 C8.12669227,42.431269 9.50357885,44.3750147 12.257352,46.4410821 C12.15359,47.3477206 12.15359,48.1543592 12.257352,48.860998 C12.361114,49.5676368 12.6510773,50.5325687 13.1272419,51.7557938 C12.0018968,51.3392886 9.93095058,49.918947 6.91440332,47.4947688 C2.38958244,43.8585016 0.981376072,34.495416 0.257996204,28.0591998 Z",
    id: "Path-6",
    fill: "url(#linearGradient-27)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.912292,166.958435 L93.4478909,190.537807 C92.9020728,190.740599 92.5399473,191.261453 92.5399473,191.843726 C92.5399473,192.453716 92.8261493,193.028364 93.3129938,193.395882 L127.875234,219.486838 C129.012952,220.345699 130.532527,220.504454 131.823197,219.899297 L196.914086,189.380072 C197.340324,189.180221 197.61255,188.751919 197.61255,188.281154 C197.61255,187.805833 197.352183,187.368702 196.934231,187.142324 L160.08189,167.181734 C159.106997,166.653696 157.951589,166.572297 156.912292,166.958435 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.962912,166.500498 L94.2221064,190.287341 C93.7239116,190.470386 93.4684323,191.02264 93.6514773,191.520835 C93.7167228,191.698414 93.8329305,191.852786 93.9855359,191.964603 L130.091355,218.419978 C130.372878,218.626255 130.744105,218.663692 131.061145,218.517778 L198.435143,187.509726 L159.752043,166.557531 C159.509389,166.4261 159.221944,166.405326 158.962912,166.500498 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-29)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "r-hand",
    transform: "translate(22.233540, 84.428205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.7398385,82.5351569 C105.973939,83.5243333 110.148989,84.0189216 112.264988,84.0189216 C115.438987,84.0189216 118.84761,84.0189216 120.339821,84.0189216 C121.334628,84.0189216 123.873577,85.377866 127.956667,88.0957549 L129.665671,91.738008 C133.196299,95.2624164 135.482479,97.4503857 136.524211,98.3019158 C138.08681,99.579211 138.685102,102.376403 134.84477,103.96481 C131.004438,105.553217 125.284765,105.35722 120.339821,102.626513 C115.394877,99.8958052 105.513398,102.872101 102.626618,101.388955 C100.702098,100.40019 97.6203853,98.5140162 93.3814788,95.7304325 C89.9916256,92.3843759 89.1441623,89.3486491 90.8390889,86.6232523 C92.5340155,83.8978554 95.500932,82.5351569 99.7398385,82.5351569 Z",
    id: "Path-15",
    fill: "#FFD0B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7673366,5.90870879 C31.6822776,10.4791919 40.209023,35.5420337 43.1202424,43.7188982 C45.0610553,49.1701412 48.2031451,54.5808924 52.5465118,59.9511518 C64.870236,65.6997622 73.7005595,69.7418711 79.0374822,72.0774787 C84.3744049,74.4130863 92.3613319,77.9490322 102.998263,82.6853165 C100.514999,83.7295515 98.8038048,85.8999835 97.8646816,89.1966125 C96.9255584,92.4932416 96.9255584,95.5283427 97.8646816,98.3019158 C84.1038048,94.5648185 73.2588399,91.5297175 65.329787,89.1966125 C53.4362075,85.6969552 34.5972186,81.0598388 31.6822776,75.5808901 C28.7673366,70.1019414 5.25421241,39.1071212 2.77071326,29.7484236 C0.287214112,20.389726 -3.78729395,8.87623805 7.77647645,2.89613165 C19.3402469,-3.08397475 25.8523956,1.33822572 28.7673366,5.90870879 Z",
    id: "Path-14",
    fill: "url(#linearGradient-30)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M226.028922,133.666212 L155.262538,166.027643 C155.053632,166.123176 154.885855,166.290379 154.789607,166.498958 L130.745069,218.605805 L198.632734,187.361344 L227.27173,135.001352 C227.526426,134.535698 227.35541,133.951739 226.889756,133.697043 C226.623742,133.551543 226.304664,133.540115 226.028922,133.666212 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-31)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128.701084,54.9906366 L172.830116,51.3132173 C173.380493,51.2673526 173.863842,51.6763406 173.909707,52.2267176 C173.912009,52.2543396 173.913161,52.2820453 173.913161,52.3097631 L173.913161,87.700894 C173.913161,88.2209826 173.514499,88.6542488 172.996207,88.6974398 L128.867175,92.3748591 C128.316798,92.4207238 127.833449,92.0117358 127.787584,91.4613588 C127.785282,91.4337368 127.78413,91.406031 127.78413,91.3783133 L127.78413,55.9871824 C127.78413,55.4670937 128.182792,55.0338276 128.701084,54.9906366 Z",
    id: "Rectangle",
    fill: "#55DFA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.735548,59.7524835 C157.835407,59.352652 161.159,55.661752 161.159,51.5086276 C161.159,47.3555031 157.835407,44.312858 153.735548,44.7126895 C149.635689,45.112521 146.312097,48.803421 146.312097,52.9565455 C146.312097,57.1096699 149.635689,60.152315 153.735548,59.7524835 Z",
    id: "Oval",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.735548,62.2591158 C161.935266,61.4594529 168.582451,67.4583827 168.582451,75.6581006 L168.582451,75.8509919 L138.888646,78.7468277 L138.888646,78.5539364 C138.888646,70.3542185 145.53583,63.0587788 153.735548,62.2591158 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.620305,71.0736906 L194.123153,68.3586414 C194.674138,68.320772 195.151499,68.7367343 195.189368,69.2877191 C195.190937,69.3105417 195.191722,69.3334114 195.191722,69.3562878 L195.191722,100.999059 C195.191722,101.524732 194.784726,101.960661 194.26029,101.996706 L154.757443,104.711755 C154.206458,104.749624 153.729097,104.333662 153.691228,103.782677 C153.689659,103.759855 153.688874,103.736985 153.688874,103.714109 L153.688874,72.071337 C153.688874,71.5456645 154.09587,71.1097352 154.620305,71.0736906 Z",
    id: "Rectangle",
    fill: "#CFFF9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.344819,73.4707687 C184.444678,73.0709372 187.76827,69.3800371 187.76827,65.2269127 C187.76827,61.0737883 184.444678,58.0311432 180.344819,58.4309747 C176.24496,58.8308062 172.921368,62.5217062 172.921368,66.6748306 C172.921368,70.827955 176.24496,73.8706001 180.344819,73.4707687 Z",
    id: "Oval",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.344819,75.977401 C188.544537,75.177738 195.191722,81.1766678 195.191722,89.3763857 L195.191722,89.5692771 L165.497916,92.4651129 L165.497916,92.2722215 C165.497916,84.0725036 172.145101,76.777064 180.344819,75.977401 Z",
    id: "Rectangle",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.84292,87.2007292 C250.499775,87.2007292 251.84292,88.5438749 251.84292,90.2007292 L251.84292,129.0861 C251.84292,130.742954 250.499775,132.0861 248.84292,132.0861 L219.969201,132.085729 L203.85078,151.053809 L203.850201,132.085729 L177.961201,132.0861 C176.304347,132.0861 174.961201,130.742954 174.961201,129.0861 L174.961201,90.2007292 C174.961201,88.5438749 176.304347,87.2007292 177.961201,87.2007292 L248.84292,87.2007292 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(195.922061, 82.122964)",
    fill: "#64DACF"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 17.48,
    cy: 8.63846154,
    rx: 8.42895238,
    ry: 8.53846154
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.48,20.0230769 C26.7903637,20.0230769 34.3379048,27.570618 34.3379048,36.8809817 L34.3379048,37.1 L34.3379048,37.1 L0.622095238,37.1 L0.622095238,36.8809817 C0.622095238,27.570618 8.16963629,20.0230769 17.48,20.0230769 Z",
    id: "Rectangle"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    opacity: 0.635370164,
    cx: 300.495942,
    cy: 186.457075,
    r: 10.5200025
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(185.663533, 191.023964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.961871,5.86455068 C206.515322,7.70401571 202.979997,9.12214687 201.355896,10.1189442 C198.919744,11.6141401 192.60065,15.3137715 191.254973,16.0053975 C189.909297,16.6970235 186.078412,18.8383111 185.474984,19.1604436 C184.871556,19.4825761 184.659411,20.3280272 184.978282,21.1412521 C185.297152,21.9544769 186.639567,22.9815434 187.413129,23.3841764 C188.18669,23.7868095 188.362695,24.3779729 188.362695,24.6472647 C188.362695,24.9165566 186.590249,28.2979696 184.978282,29.4690759 C183.366314,30.6401823 180.184391,33.1535728 180.184391,34.4869848 C180.184391,35.8203969 179.584225,36.737607 180.912158,38.4480799 C182.24009,40.1585527 190.491066,46.8650153 191.889714,48.5595707 C192.822146,49.6892743 192.974884,56.0819981 192.347928,67.7377419 L221.375192,61.492165 C221.868647,55.6423322 222.115374,52.2859052 222.115374,51.422884 C222.115374,50.1283522 226.164667,49.8334881 228.248548,49.1965294 C230.332428,48.5595707 233.814173,47.6165274 235.248831,46.4926515 C236.683488,45.3687756 240.993462,40.1755139 241.604327,37.0673068 C242.215191,33.9590998 243.612795,28.1774145 242.913993,23.9955628 C242.215191,19.8137112 238.794506,11.8868242 234.2429,8.8382423 C229.691294,5.78966041 225.408719,4.73415124 220.899647,4.73415124 C217.893598,4.73415124 214.91434,5.11095105 211.961871,5.86455068 Z",
    id: "Path-2",
    fill: "#FFD8C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.034004,29.3215056 L191.759954,29.2872661 C190.948918,31.3448657 189.018269,32.3736656 185.968006,32.3736656 C185.764737,32.3736656 185.335976,32.3524878 184.681722,32.3101323 C184.79191,31.832382 184.883988,31.3692576 184.957957,30.9207592 C185.031926,30.4722608 185.057275,29.9391762 185.034004,29.3215056 Z",
    id: "Rectangle",
    fill: "#FF6D4F",
    transform: "translate(188.220838, 30.830466) rotate(38.000000) translate(-188.220838, -30.830466) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.355896,10.1189442 C198.919744,11.6141401 192.60065,15.3137715 191.254973,16.0053975 C189.909297,16.6970235 186.078412,18.8383111 185.474984,19.1604436 C184.871556,19.4825761 184.659411,20.3280272 184.978282,21.1412521 C185.297152,21.9544769 186.639567,22.9815434 187.413129,23.3841764 C188.18669,23.7868095 188.362695,24.3779729 188.362695,24.6472647 C188.362695,24.8267926 190.034509,23.3137456 193.378137,20.1081237 C200.320744,12.4518734 202.979997,9.12214687 201.355896,10.1189442 Z",
    id: "Path-2",
    fill: "url(#linearGradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.777992,52.7189814 C229.883701,50.2596929 235.006416,48.106315 237.146138,46.2588478 C240.355721,43.4876469 247.133942,29.8727528 243.744831,21.192788 C240.355721,12.5128233 233.974285,6.65207273 229.975537,5.05197823 C225.976789,3.45188372 218.960328,3.54608367 216.082141,4.2464512 C213.203954,4.94681872 210.038209,5.88829638 209.594869,6.99547201 C209.151529,8.10264764 208.55319,13.2024922 209.594869,15.1253716 C210.636549,17.048251 211.491915,17.9080539 211.491915,19.550421 C211.491915,21.192788 208.785428,25.082385 208.314167,26.2482725 C207.842907,27.4141601 207.368254,29.616508 208.314167,30.4927502 C209.260081,31.3689925 212.919308,30.2965791 214.565589,30.8304658 C216.211871,31.3643525 216.728754,34.2762744 216.082141,36.2359466 C215.435527,38.1956188 211.60492,38.9829669 210.468422,38.9829669 C209.710756,38.9829669 208.992671,42.2438718 208.314167,48.7656817 C211.685531,50.2389027 214.274855,51.2408558 216.082141,51.7715411 C217.889426,52.3022263 219.788043,52.6180398 221.777992,52.7189814 Z",
    id: "Path",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.032766,172.799006 C190.559662,161.700863 162.065201,161.45347 151.299852,161.463484 L149.464137,161.466097 C140.570013,161.466097 114.717448,161.785099 107.516099,165.614107 C94.5490782,172.508763 95.6809082,182.765692 99.1094204,189.213757 C103.051876,196.628405 107.248402,205.394633 111.699,215.512442 L136.492406,207.647277 C137.762865,203.426656 138.183882,198.479774 137.755458,192.806633 C145.561244,194.197814 153.143047,196.41035 160.500868,199.44424 L161.244487,199.753677 C172.26418,204.377635 188.19645,212.626166 199.508677,206.109259 C211.077999,199.44424 214.238195,184.605541 202.032766,172.799006 Z",
    id: "Path-17",
    fill: "#424242",
    transform: "translate(153.327807, 188.487963) rotate(28.000000) translate(-153.327807, -188.487963) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.85597,161.676467 C127.691175,155.837882 120.295242,151.687832 112.667949,154.087369 C104.932435,156.520952 97.6927022,165.333445 101.121214,171.781539 C105.06367,179.196219 109.260197,187.962487 113.710794,198.080341 L138.5042,190.215141 L137.234771,177.912653 C136.425433,170.980918 134.632499,165.568856 131.85597,161.676467 Z",
    id: "Path-17",
    fill: "url(#linearGradient-33)",
    transform: "translate(119.375535, 175.737480) rotate(28.000000) translate(-119.375535, -175.737480) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5713411,250.593435 C47.3031978,259.708861 44.4163214,265.666912 40.9107117,268.467591 C37.4051019,271.268269 31.8441818,272.059274 24.2279513,270.840607 C27.3019641,281.91226 31.5258624,287.448087 36.8996462,287.448087 C42.2734301,287.448087 48.4806075,285.891038 55.5211786,282.776941 C63.6017946,270.93645 68.7532035,262.022682 70.9754055,256.035635 C73.1976074,250.048589 66.0629193,248.234522 49.5713411,250.593435 Z",
    id: "Path-22",
    fill: "#FFD8C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.80329,179.479124 C130.75972,181.236348 112.044094,182.518867 103.656414,183.326679 C91.0748932,184.538398 79.8461475,188.585381 74.8746018,196.36656 C71.5602381,201.554013 61.0643519,220.656651 43.3869434,253.674474 C46.7929461,258.724014 50.5375723,261.926687 54.620822,263.282493 C58.7040716,264.638299 63.7673844,265.422885 69.8107602,265.636251 C77.1263417,255.872661 82.3653552,248.36408 85.5278007,243.11051 C88.6902462,237.85694 92.9303749,230.079048 98.2481867,219.776834 C99.6510093,219.848875 101.323646,219.884896 103.266096,219.884896 C106.179771,219.884896 109.564684,217.652044 112.622682,218.069304 C114.504547,218.326082 115.535574,218.069304 119.135004,220.047096 C122.734434,222.024888 160.677496,227.661718 169.364194,227.661718 C186.656279,227.661718 205.246354,230.444005 215.999482,219.138121 C223.168234,211.600864 228.036993,200.067623 230.605758,184.538398 C222.172431,179.026916 212.434914,176.271175 201.393207,176.271175 C190.3515,176.271175 176.488194,177.340491 159.80329,179.479124 Z",
    id: "Path-19",
    fill: "url(#linearGradient-34)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.127449,37.0607435 C115.936279,26.7969536 116.840693,20.7592694 116.840693,18.9476911 C116.840693,16.2303236 112.613129,5.79613641 111.889396,4.63611289 C111.165663,3.47608936 105.777162,0.215909916 105.17961,0.0219242586 C104.582059,-0.172061398 103.648325,0.952262526 104.284365,2.1672599 C104.708391,2.97725816 106.014559,4.44478759 108.202866,6.5698482 C109.090885,10.3976047 109.420981,12.3887281 109.193153,12.5432183 C108.851412,12.7749536 106.262369,10.904186 104.957907,11.1245332 C103.653446,11.3448805 99.6207751,14.8272103 98.5098515,15.7435415 C97.3989279,16.6598727 98.1115386,21.3282556 98.5098515,24.8511269 C98.7753934,27.1997078 99.3603754,29.3377087 100.264797,31.2651298 L103.308935,43.2870968 L114.127449,37.0607435 Z",
    id: "Path-25",
    fill: "#FFD8C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.509348,60.4466557 L191.08185,67.7377419 C182.260629,70.9325323 177.011177,73.1153933 175.333496,74.286325 C173.655815,75.4572568 163.342813,76.9535049 144.39449,78.7750695 L126.01134,78.7750695 L114.120748,36.2359466 C109.60263,35.3905559 106.353384,35.9280835 104.37301,37.8485294 C102.392637,39.7689754 101.735412,41.3120897 102.401335,42.4778725 C105.133813,78.3624835 107.015699,97.291818 108.046992,99.265876 C109.593932,102.226963 116.166582,105.765287 119.82235,105.765287 C122.259529,105.765287 137.900192,106.664332 166.744339,108.462422 C167.128548,121.4453 166.631939,133.486117 165.254513,144.584872 C163.877087,155.683628 162.235017,165.54802 160.328305,174.178047 C171.582062,180.766984 183.293238,184.965326 195.461832,186.773075 C207.630426,188.580825 219.345068,187.432026 230.605758,183.326679 C235.567996,152.618095 238.613148,132.026857 239.741214,121.552964 C241.692593,103.434768 242.947666,89.4536979 242.947666,86.3628308 C242.947666,77.7062523 242.774793,72.3230465 238.587852,67.7377419 C235.796558,64.6808722 231.103723,62.2505101 224.509348,60.4466557 Z",
    id: "Path-18",
    fill: "#FF7676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.384706,225.135802 C103.419355,222.653224 104.43668,221.019642 104.43668,220.235056 C104.43668,219.058177 107.412981,218.069304 110.920038,218.069304 C114.427094,218.069304 119.38603,218.479701 120.455369,220.958125 C121.168262,222.610408 121.870891,224.744042 122.563256,227.359025 C123.968514,230.858557 123.968514,233.136404 122.563256,234.192567 C120.455369,235.776811 109.769807,238.043227 106.500729,235.007851 C104.321344,232.984267 102.616003,229.693584 101.384706,225.135802 Z",
    id: "Path-24",
    fill: "url(#linearGradient-35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6663478,240.310448 C66.2726304,238.237728 66.2726304,236.427501 66.6663478,234.879769 C67.2569238,232.558171 69.7397841,230.841957 71.4118985,230.096368 C73.0840129,229.350779 79.3581044,227.45389 88.1831435,226.023597 C97.0081825,224.593304 100.419039,222.390956 102.311571,222.390956 C104.204103,222.390956 105.993458,223.954591 108.209636,224.593304 C110.425814,225.232017 114.696067,225.990899 119.375535,224.231117 C124.055002,222.471335 122.476624,226.403979 124.638265,229.232587 C126.799906,232.061195 127.679801,236.877578 127.239853,238.310448 C126.799906,239.743318 124.902338,242.168183 119.603134,243.189836 C114.30393,244.21149 106.427143,248.3116 90.4549019,245.750718 C79.8067409,244.043464 71.8772229,242.23004 66.6663478,240.310448 Z",
    id: "Path-21",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4285304,237.118421 C69.2932915,234.217153 71.4025942,232.689659 77.4866792,231.710278 C83.5707643,230.730898 103.966378,233.943347 107.882058,233.943347 C111.797738,233.943347 120.189721,232.388858 124.01664,233.943347 C127.84356,235.497837 128.509268,241.632116 125.314895,243.292911 C122.120523,244.953706 107.743814,248.524529 98.5703802,248.524529 C89.3969466,248.524529 72.0002249,247.308517 69.7143776,244.953706 C67.4285304,242.598894 65.5637693,240.019688 67.4285304,237.118421 Z",
    id: "Path-20",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.576371,268.180093 C38.2675186,267.95301 38.854506,268.066551 39.3373331,268.520716 C38.6648101,271.89595 38.6648101,275.121289 39.3373331,278.196731 C40.3461176,282.809895 48.1515553,283.514723 49.5366339,283.514723 C50.9217124,283.514723 55.7042519,281.688653 55.7042519,281.688653 C55.7042519,281.688653 57.0457532,281.029765 57.0457532,283.514723 C57.0457532,285.999681 56.1342838,287.448087 55.7042519,288.216892 C55.27422,288.985698 54.0608411,293.819833 53.0708283,295.754976 C52.0808155,297.69012 50.8990105,300.022678 48.8975877,300.022678 C46.8961648,300.022678 40.1082884,300.022678 32.8937722,295.754976 C25.6792561,291.487275 10.8269764,284.044957 7.93626425,281.688653 C5.0455521,279.332349 -1.57949673,273.610942 0.344948307,270.105973 C2.26939335,266.601004 3.94017437,266.729387 6.48932818,266.729387 C9.03848199,266.729387 15.8839736,267.691147 20.0559625,268.520716 C24.2279513,269.350286 30.8599926,270.105973 32.8937722,270.105973 C34.9275518,270.105973 36.5396497,268.520716 37.576371,268.180093 Z",
    id: "Path-23",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeIllustration);
export default __webpack_public_path__ + "static/media/welcome-illustration.232aea3fd496db7dd692e5f8e2706902.svg";
export { ForwardRef as ReactComponent };